<template>
  <div ref="main">
    <a href="#main" class="skip">{{ $t('component.header.a11y.skipButton') }}</a>
    <maintenance-info />
    <bm-privacy />
    <div class="container">
      <header>
        <topup-header />
      </header>
      <main id="main">
        <router-view />
      </main>
      <topup-banners />
      <footer>
        <topup-footer />
      </footer>
    </div>
  </div>
</template>

<script>
import TopupHeader from './components/Header'
import TopupFooter from './components/Footer'
import langParamMixin from '../common/mixins/params/lang.mixin'
import backUrlParamMixin from '../common/mixins/params/backUrl.mixin'
import piwikToolMixin from '../common/mixins/tools/piwik.mixin'
import eventsMixin from '@/common/mixins/tools/events.mixin'
import TopupBanners from '@/common/components/bannersSlider'
import MaintenanceInfo from '@/common/components/maintenanceInfo'

export default {
  mixins: [
    langParamMixin,
    backUrlParamMixin,
    piwikToolMixin,
    eventsMixin
  ],
  components: {
    MaintenanceInfo,
    TopupBanners,
    TopupFooter,
    TopupHeader
  }
}
</script>

<style src="./assets/scss/app.scss" lang="scss"></style>
<style lang="scss">
.skip {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;

  &:focus {
    position: static;
    width: auto;
    height: auto;
  }
}
</style>
